<script>
  import { getContext } from 'svelte'

  export let addBlock

  const platform = getContext('platform')

  const { store } = platform
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->

{#if $store.layouts?.length}
  <div class="layouts add-layouts">
    {#each $store.layouts as layout}
      <div class="layout-container" on:click={() => addBlock(layout)}>
        <div class={`outside ${layout.classNames?.join(' ')} ${layout?.rowClassNames?.join(' ')} layout`}>
          {#each layout.rows[0] as row}
            <div class={`${row.classNames?.join(' ')} row`}>
            </div>
          {/each}
        </div>
        <p>{layout.displayName}</p>
      </div>
    {/each}
  </div>
{/if}

<style lang="scss">.layouts {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 2rem;
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  height: 100%;
  overflow-y: auto;
}

.layout-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  text-align: center;
}

.layout {
  width: 100%;
  height: 125px;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 1rem;
  padding: 1rem;
  gap: 5px;
  margin: 0;
  position: relative;
  transition: 0.3s;
  overflow: hidden;
}
.layout:hover {
  transform: translateY(-0.5rem);
  cursor: pointer;
}

.row {
  background-color: rgb(228, 228, 228);
  height: 100%;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>